import React, { useEffect, useState } from "react";
import "../../../incidents/cases/addCaseList.scss";
import FilterListIcon from "@mui/icons-material/FilterList";
import ViewcCasetable from "../../../../library/custom/gridTable/GridTable";
import SearchIcon from "@mui/icons-material/Search";
import Buttons from "../../../../library/custom/button/Button";
import SettingTable from "../../../incidents/incidentList/SettingTable";
import { useNavigate } from "react-router-dom";
import UserFilterList from "../../shared/UserFilterList ";
import { TableLoader } from "../../../../library/common/Loader";
import downloadIcon from "../../../../assets/downloadIcon.svg";
import {
  LOGIN_ORG_ID,
  ORG_ID,
  PAGE_SIZE,
  ROW_PER_PAGE_SIZE,
  HBNEXT_ORG_ID,
} from "../../../../constant/constant";
import {
  ADD_ADMIN_USER,
  ADMIN_SAFETY_LOG,
  VIEW_ADMIN_USER,
} from "../../../../constant/routeContant";
import DialogBox from "../../../../library/common/DialogBox";
import NORow from "../../../../library/custom/noRow/noRow";
import ReportRowManipulte from "../../../incidents/incidentList/ReportRowManipulte";
import { checkPrivileges } from "../../../../utils/rolesHelper";
import { encodeSearchText, InactiveClient } from "../../../../utils/helper";
import check_Icon from "../../..../../../../assets/check_Icon.svg";
import cross_Icon from "../../..../../../../assets/cross_Icon.svg";
import verifyEmailCheckBox from "../../..../../../../assets/verifyEmailCheckBox.svg";
import { Grid } from "@mui/material";

export default function UserList({
  NavigateSingleUser,
  userListData,
  loading,
  getuserLists,
  jobTitles,
  deleteList,
  isDivision = true,
  division,
  isShowDowdownloadButton = true,
  sendBulkEmailVarifation,
  setClickVerifyBtn,
  setAccessUserId,
  accessUserId,
  handleToNonPreUserOnClick,
  setClickUserToNoUserBtn,
  userListDatas,
  shouldRestoreState,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElAdd, setAnchorElAdd] = useState(null);
  const [search, setSearch] = useState("");
  const [jobTitle, setjobTitle] = useState("");
  const [divisionfilter, setDivisionFilter] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [isTableLoading, setisTableLoading] = useState(false);
  const [emailVerifiedValue, setEmailVerifiedValue] = useState(3);
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));
  const isProcoreClient = userInfo?.isProcoreConnected;
  const ProcoreClientId = localStorage.getItem("IsProcoreConnected");
  const isClientSwitch = parseInt(ORG_ID()) !== parseInt(LOGIN_ORG_ID());

  let ShowField = false;
  const [openModal, setOpenModal] = useState(false);
  const [openModal1, setOpenModal1] = useState(false);
  const [selectedRow, setSelectedRow] = useState("");

  if (isClientSwitch) {
    if (ProcoreClientId === "true") {
      ShowField = true;
    }
  } else {
    if (isProcoreClient) {
      ShowField = true;
    }
  }

  const navigate = useNavigate();

  const deletehandle = () => {
    setOpenModal(false);
    deleteList(selectedRow.userid);
  };
  const handleChangeUserToNonUser = () => {
    setOpenModal1(false);
    handleToNonPreUserOnClick(selectedRow?.userid);
    setClickUserToNoUserBtn(true);
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    window.close();
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  const openAdd = Boolean(anchorElAdd);
  const idAdd = openAdd ? "simple-popover" : undefined;

  useEffect(() => {
    if (shouldRestoreState && userListDatas?.filterObj) {
      const f = userListDatas.filterObj;
      setSearch(decodeURIComponent(f.search || ""));
      setEmailVerifiedValue(
        f.isEmailVerified === "" ? 3 : f.isEmailVerified === true ? 1 : 2,
      );
      setDivisionFilter(f.divisionId === 0 ? "" : f.divisionId || "");
      setDesignation(
        jobTitles?.find((x) => x.value === f.designation)?.key || "",
      );
      setjobTitle(f.designation || "");
      setPage((f.page || 1) - 1);
      setPageSize(f.pageSize || PAGE_SIZE);
    } else if (shouldRestoreState === false) {
      setSearch("");
      setEmailVerifiedValue(3);
      setDivisionFilter("");
      setDesignation("");
      setjobTitle("");
      setPage(0);
      setPageSize(PAGE_SIZE);
    }
  }, [shouldRestoreState]);

  const handleClickAdd = (event) => {
    if (InactiveClient()) return;
    NavigateSingleUser();
  };

  const handleautoSearch = (event) => {
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    setPage(0);
    let searchText = "";
    if (event.target.value) {
      searchText = event.target.value;
    }
    setSearch(event.target.value);
    const data = {
      page: 1,
      pageSize: pageSize,
      search: searchText ? encodeSearchText(searchText) : "",
      orgId: ORG_ID(),
      designation: jobTitle,
      divisionId: divisionfilter ? divisionfilter : 0,
      IsProcoreUsers: false,
      isSendMail: false,
      isEmailVerified:
        emailVerifiedValue === 1 ? true : emailVerifiedValue === 2 ? false : "",
    };
    getuserLists(data);
  };

  const handlePagignation = (newPage) => {
    setPage(newPage);
    getuserLists({
      page: newPage + 1,
      pageSize: pageSize,
      search: search ? encodeSearchText(search) : "",
      orgId: ORG_ID(),
      designation: jobTitle ? jobTitle : "",
      divisionId: divisionfilter ? divisionfilter : 0,
      IsProcoreUsers: false,
      isSendMail: false,
      isEmailVerified:
        emailVerifiedValue === 1 ? true : emailVerifiedValue === 2 ? false : "",
    });
  };

  const handlePageSizeChange = (newPazeSize) => {
    setPageSize(newPazeSize);
    setPage(0);
    getuserLists({
      page: 1,
      pageSize: newPazeSize,
      search: search ? encodeSearchText(search) : "",
      orgId: ORG_ID(),
      designation: jobTitle ? jobTitle : "",
      divisionId: divisionfilter ? divisionfilter : 0,
      IsProcoreUsers: false,
      isSendMail: false,
      isEmailVerified:
        emailVerifiedValue === 1 ? true : emailVerifiedValue === 2 ? false : "",
    });
  };

  const handleViewOnClick = (rows) => {
    navigate(ADMIN_SAFETY_LOG, {
      state: { userId: rows.row, userSafetyLog: false },
    });
  };

  const handleOnclick = (rows) => {
    if (InactiveClient()) return;
    sessionStorage.setItem("userListPreserveState", "true");
    navigate(ADD_ADMIN_USER, {
      state: { userId: rows.row.userid, editMode: true },
    });
  };

  const handleViewOnclick = (rows) => {
    sessionStorage.setItem("userListPreserveState", "true");
    navigate(VIEW_ADMIN_USER, {
      state: { userId: rows.row.userid },
    });
  };

  const deleteIncidents = (rows) => {
    if (InactiveClient()) return;
    setOpenModal(true);
    setSelectedRow(rows);
  };
  const handleToNonPreUserOnClickPopUp = (rows) => {
    if (InactiveClient()) return;
    setOpenModal1(true);
    setSelectedRow(rows);
  };

  const columns = [
    { field: "userid", headerName: "User ID", flex: 0.8 },
    { field: "userName", headerName: "Name", flex: 1.2 },
    { field: "jobtitle", headerName: "Job Title", flex: 1 },
    { field: "phoneNumber", headerName: "Phone Number", flex: 1.2 },
    {
      field: "email",
      headerName: "Email ID",
      flex: 2.5,
      renderCell: (rows) => {
        const email = rows?.row?.email || "";
        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
              width: "100%",
            }}
          >
            <div
              title={email}
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                flex: 1,
                minWidth: "0",
                textAlign: "left",
              }}
            >
              {email}
            </div>
            {/* <div>
              {rows?.row?.isEmailVerified ? (
                <img src={check_Icon} alt="check-icon" width="16" height="16" />
              ) : (
                <img src={cross_Icon} alt="cross-icon" width="18" height="18" />
              )}
            </div> */}
          </div>
        );
      },
    },
    {
      field: "divisions",
      headerName: "Divisions",
      flex: 2.5,
      renderCell: (rows) => {
        const divisionsArr = rows?.row?.divisions ?? [];
        const divisionNames = [
          ...new Set(divisionsArr.map((d) => d?.value).filter(Boolean)),
        ];
        const displayText =
          divisionNames.length > 0 ? divisionNames.join(", ") : "N/A";

        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
              width: "100%",
            }}
          >
            <div
              title={displayText !== "N/A" ? displayText : ""}
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                flex: 1,
                minWidth: "0",
                textAlign: "left",
              }}
            >
              {displayText}
            </div>
          </div>
        );
      },
    },
    {
      field: "isEmailVerified",
      headerName: "Verified Email",
      flex: 1.5,
      renderCell: (rows) => {
        return rows?.row?.isEmailVerified ? (
          <img src={check_Icon} alt="Verified" width="16" height="16" />
        ) : (
          <img src={cross_Icon} alt="Not Verified" width="18" height="18" />
        );
      },
    },
    ...(ShowField
      ? [
          {
            field: "procoreUserId",
            headerName: "Procore User",
            flex: 3.5,
            renderCell: (params) => {
              return params.row.procoreUserId === null ? "No" : "Yes";
            },
          },
        ]
      : []),
    isDivision && {
      field: "",
      width: 68,
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (rows) => {
        return (
          isDivision &&
          rows?.row?.isOrganiztion === false && (
            <ReportRowManipulte
              rows={rows}
              safetyLogOnClick={() => handleViewOnClick(rows)}
              editOnClick={() => handleOnclick(rows)}
              deleteOnClick={() => deleteIncidents(rows?.row)}
              edit={checkPrivileges([64, 65, 12])}
              editLabel="Edit User"
              safetyLog={checkPrivileges([64, 65, 66, 12])}
              safetyLogLabel="Safety Log"
              deleted={checkPrivileges([64, 12])}
              deleteLabel="Delete User"
              convertToNonPreUserLabel="Convert to Non-Privileged User"
              convertToNonPreUser={
                isClientSwitch ||
                (parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID) &&
                  checkPrivileges([12]))
              }
              convertToNonPreUserOnClick={() =>
                handleToNonPreUserOnClickPopUp(rows?.row)
              }
              // viewOnClick={() => handleViewOnclick(rows)}
              // view={true}
              // viewLabel={"View User"}
            />
          )
        );
      },
    },
  ];

  const handleSearch = (event) => {
    getuserLists({
      page: 1,
      pageSize: pageSize,
      search: encodeSearchText(search),
      designation: jobTitle ? jobTitle : "",
      IsProcoreUsers: false,
      isSendMail: false,
      divisionId: divisionfilter ? divisionfilter : 0,
      isEmailVerified:
        emailVerifiedValue === 1 ? true : emailVerifiedValue === 2 ? false : "",
    });
  };
  const [designation, setDesignation] = useState("");
  const designationOnChanges = (e) => {
    let title = jobTitles?.find((x) => x.key === e.target.value)?.value;
    setjobTitle(title);
    setDesignation(e.target.value);
  };

  const divisionFilterOnChanges = (e) => {
    setDivisionFilter(e.target.value);
  };

  const onRowClick = (e) => {
    // console.log("ROW CLICK");
  };

  const handleClear = () => {
    setEmailVerifiedValue(3);
    setDesignation("");
    setAnchorEl(null);
    setDivisionFilter("");
    setSearch("");
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    setPage(0);
    setPageSize(PAGE_SIZE);
    window.close();
    const data = {
      page: 1,
      pageSize: PAGE_SIZE,
      search: "",
      designation: "",
      IsProcoreUsers: false,
      divisionId: 0,
      isSendMail: false,
      isEmailVerified: "",
    };
    getuserLists(data);
  };
  const handleApply = () => {
    setAnchorEl(null);
    window.close();
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    setPage(0);
    const data = {
      page: 1,
      pageSize: pageSize,
      search: search ? encodeSearchText(search) : "",
      designation: jobTitle,
      IsProcoreUsers: false,
      isSendMail: false,
      divisionId: divisionfilter ? divisionfilter : 0,
      isEmailVerified:
        emailVerifiedValue === 1 ? true : emailVerifiedValue === 2 ? false : "",
    };
    getuserLists(data);
  };

  const sendEmail = () => {
    const data = {
      page: page + 1,
      pageSize: pageSize,
      search: encodeSearchText(search),
      designation: jobTitle ? jobTitle : "",
      IsProcoreUsers: false,
      divisionId: divisionfilter ? divisionfilter : 0,
      isSendMail: true,
      isEmailVerified:
        emailVerifiedValue === 1 ? true : emailVerifiedValue === 2 ? false : "",
    };
    getuserLists(data);
  };

  const sendBulkEmailVerify = () => {
    if (accessUserId?.length > 0) {
      setClickVerifyBtn(true);
      const data = {
        ids: accessUserId,
        type: 1,
      };
      sendBulkEmailVarifation(data);
    }
  };

  const yesnoOnChanges = (e) => {
    setEmailVerifiedValue(e?.target.value);
  };
  return (
    <>
      <section className="grid_main_sec">
        {isDivision && (
          <div className="grid_main_header two_grid">
            <div className="grid_heading_style"> Users List</div>
            {openModal1 && (
              <DialogBox
                open={openModal1}
                rows={[]}
                header={
                  "Are you sure you want to convert the user to a non-privileged user? Converting the user will remove all the mapping of this user."
                }
                handleChangeUserToNonUser={handleChangeUserToNonUser}
                handleCloseModal={() => setOpenModal1(false)}
                content={"Are you sure you want to do it? "}
                view
                deleteView={false}
                UserToNonUserView={true}
              />
            )}
            {openModal && (
              <DialogBox
                open={openModal}
                rows={[]}
                header={"Confirm Deletion"}
                deletehandle={deletehandle}
                handleCloseModal={() => setOpenModal(false)}
                content={"Are you sure you want to delete this User?"}
                view
              />
            )}
            <div>
              <div className="filter_btn">
                {checkPrivileges([12, 64, 65]) && (
                  <Buttons
                    id="btnAddUsers"
                    aria-describedby={idAdd}
                    varientAddIconBlue={true}
                    label={"Add User"}
                    onClick={(e) => handleClickAdd(e)}
                  />
                )}
              </div>
            </div>
          </div>
        )}
        <div className={accessUserId?.length > 0 ? "userMain" : ""}>
          {" "}
          <div className="grid_main_body">
            <Grid
              container
              className="fixedDesign div-filter-container gapNone"
            >
              <Grid item sm={6} md={6} xs={12}>
                <div className="filter_of_caselist">
                  <div className="searchcaseid">
                    <label htmlFor="search">
                      <span>
                        <SearchIcon />
                      </span>
                      <div>
                        <input
                          id="search"
                          placeholder="Search"
                          type="text"
                          value={search}
                          className=""
                          onChange={handleautoSearch}
                          autoComplete="off"
                        />
                      </div>
                    </label>
                  </div>

                  {isDivision && (
                    <div className="filter_btn">
                      <button
                        aria-describedby={id}
                        variant="contained"
                        type="button"
                        name="btn"
                        onClick={(e) => handleClick(e)}
                      >
                        <FilterListIcon id="icn" /> Filters
                      </button>
                      <UserFilterList
                        firstLabel="Division"
                        secondLabel="Job Title"
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        handleClose={handleClose}
                        handleSearch={handleSearch}
                        handleApply={handleApply}
                        secondLebelFilter={jobTitles}
                        firstLebelFilter={division}
                        resetBtn={true}
                        handleClear={handleClear}
                        secondLebelOnChanges={designationOnChanges}
                        secondLebelValue={designation}
                        isShow={true}
                        firstLebelOnChanges={divisionFilterOnChanges}
                        firstLebelValue={divisionfilter}
                        yesnoshow={true}
                        yesnoOnChanges={yesnoOnChanges}
                        yesno={emailVerifiedValue}
                      />
                    </div>
                  )}
                </div>
              </Grid>
              <Grid item sm={6} md={6} xs={12}>
                <Grid container spacing={2}>
                  <Grid item md={7} xs={12} className="emailRight">
                    {accessUserId?.length > 0 && (
                      <div
                        className={`div-verify-email-right ${
                          accessUserId?.length === 0 ? "asscssuser" : ""
                        }`}
                        onClick={sendBulkEmailVerify}
                      >
                        <span>
                          <img
                            src={verifyEmailCheckBox}
                            className="DownLoadLogo"
                            alt="DownLoad Logo"
                          />
                        </span>
                        Verify Selected Emails
                      </div>
                    )}
                  </Grid>
                  <Grid item md={5} xs={12}>
                    {isShowDowdownloadButton && (
                      <div
                        className="div-download-email-right"
                        onClick={sendEmail}
                      >
                        <span>
                          <img
                            src={downloadIcon}
                            className="DownLoadLogo"
                            alt="DownLoad Logo"
                          />
                        </span>
                        Download Data
                      </div>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {isTableLoading ? (
              ""
            ) : (
              <div className="desc_box row_uniq">
                <div className="table_style_ui">
                  <ViewcCasetable
                    getRowId={(r) => r.userid}
                    rows={userListData?.userData || []}
                    rowCount={userListData?.itemsCount}
                    onRowClick={onRowClick}
                    columns={columns}
                    loading={loading}
                    components={{
                      LoadingOverlay: TableLoader,
                      NoRowsOverlay: NORow,
                    }}
                    checkboxSelection={true}
                    page={page}
                    pagination
                    pageSize={pageSize}
                    rowsPerPageOptions={ROW_PER_PAGE_SIZE}
                    onPageSizeChange={handlePageSizeChange}
                    onPageChange={handlePagignation}
                    backIconButtonProps={{ disabled: false }}
                    disableSelectionOnClick
                    isRowSelectable={(params) =>
                      params.row.isEmailVerified === false
                    }
                    onSelectionModelChange={setAccessUserId}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
